import { render, staticRenderFns } from "./DurationInfoModal.vue?vue&type=template&id=126532e2"
import script from "./DurationInfoModal.vue?vue&type=script&lang=ts"
export * from "./DurationInfoModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports